import { render, staticRenderFns } from "./work_item_relationship_popover_metadata.vue?vue&type=template&id=2e955ef6&vue3"
import script from "./work_item_relationship_popover_metadata.vue?vue&type=script&lang=js&vue3"
export * from "./work_item_relationship_popover_metadata.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports